/**
 * RunRun 2026-07-16 — Sinónimos de búsqueda DM CL.
 * El search nativo no encuentra términos que sí tienen producto con otro nombre
 * (mary jane = merceditas, mule = zuecos, etc). Remapea la query en:
 *  1. el fetch de la búsqueda predictiva (dropdown del header),
 *  2. la página /search (redirect con la query mapeada),
 *  3. el submit de cualquier form de búsqueda.
 * Fuente: top búsquedas GA4 jun-jul 2026 con 0 resultados en el dropdown.
 * 2026-07-16 v2: sugerencias del dropdown ocultan agotados
 * (resources[options][unavailable_products]=hide); la página /search los
 * manda al final (options[unavailable_products]=last via hidden input).
 */
(function () {
  'use strict';

  var SYN = {
    'mary jane': 'merceditas',
    'mary janes': 'merceditas',
    'maryjane': 'merceditas',
    'mary-jane': 'merceditas',
    'mule': 'zuecos',
    'mules': 'zuecos',
    'zapatilla': 'zapatos',
    'zapatillas': 'zapatos',
    'buzo': 'buzz',
    'oxford': '1461',
    '1490': '1460',
    '11822006': '1460'
  };

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function mapTerm(q) {
    var n = norm(q);
    var m = SYN[n];
    // Sin match exacto: si lo tipeado (>=4 chars) es prefijo de un sinónimo
    // conocido, mapear igual — cubre estados intermedios como "mary" o "zapati".
    if (!m && n.length >= 4) {
      for (var key in SYN) {
        if (key.indexOf(n) === 0) { m = SYN[key]; break; }
      }
    }
    return m && m !== n ? m : null;
  }

  // 1) Dropdown predictivo: interceptar el fetch a predictive_search_url.
  //    Además de los sinónimos, ocultamos productos agotados de las sugerencias
  //    (en la página /search completa quedan al final, no se ocultan).
  var predictivePath = (window.Theme && Theme.routes && Theme.routes.predictive_search_url) || '/search/suggest';
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var urlStr = typeof input === 'string' ? input : (input && input.url);
      if (urlStr && urlStr.indexOf(predictivePath) !== -1) {
        var u = new URL(urlStr, location.origin);
        var mapped = mapTerm(u.searchParams.get('q'));
        if (mapped) u.searchParams.set('q', mapped);
        u.searchParams.set('resources[options][unavailable_products]', 'hide');
        input = typeof input === 'string' ? u.toString() : new Request(u.toString(), input);
      }
    } catch (e) { /* ante cualquier duda, no tocar el request */ }
    return origFetch.call(this, input, init);
  };

  // 2) Página de resultados: si llegó con un término mapeable, redirigir.
  //    rr_from conserva el término original para poder leer la demanda real en GA4.
  if (location.pathname.replace(/\/$/, '').slice(-7) === '/search') {
    var pageUrl = new URL(location.href);
    var mappedQ = mapTerm(pageUrl.searchParams.get('q'));
    if (mappedQ && !pageUrl.searchParams.get('rr_from')) {
      pageUrl.searchParams.set('rr_from', pageUrl.searchParams.get('q'));
      pageUrl.searchParams.set('q', mappedQ);
      pageUrl.searchParams.delete('page');
      location.replace(pageUrl.toString());
    }
  }

  // 3) Submit de forms de búsqueda (header/modal): remapear antes de navegar
  //    + pedir que los agotados vayan al final del listado de resultados.
  document.addEventListener('submit', function (e) {
    try {
      var form = e.target;
      if (!form || !form.action) return;
      var action = new URL(form.action, location.origin);
      if (action.pathname.replace(/\/$/, '').slice(-7) !== '/search') return;
      var input = form.querySelector('input[name="q"]');
      var mapped = input && mapTerm(input.value);
      if (mapped) input.value = mapped;
      if (!form.querySelector('input[name="options[unavailable_products]"]')) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'options[unavailable_products]';
        hidden.value = 'last';
        form.appendChild(hidden);
      }
    } catch (err) { /* noop */ }
  }, true);
})();
